import React from 'react';
import Whatsapp from 'Assets/SVG/whatsappicon.svg';
import { useSelector } from 'react-redux';
import GetACallBackModal from './GetACallBackModal';
import fixedCall from 'Assets/Icons/fixed-call-icon.svg';

function WhatsappIcon() {
  const homeData = useSelector((e) => e?.states.homePageData);

  return (
    <>
      <GetACallBackModal>
        <div className="callback-fixed">
          <div
            to=""
            className="callback-text seo-call-back"
          >
            <img
              src={fixedCall}
              alt=""
            />
            Get a Call Back
          </div>
        </div>
      </GetACallBackModal>
      <a
        href={`https://wa.me/${
          homeData?.whatsapp_channel_number
        }?text=${encodeURIComponent('Hi')}`}
        target="_blank"
        className="whatsapp cursor-pointer whatsapp-button"
      >
        <img
          src={Whatsapp}
          alt=""
        />
      </a>
    </>
  );
}

export default WhatsappIcon;
